// Server Error Codes
export const RestrictionRuleNotSatisfied = 'RestrictionRuleNotSatisfied';
export const AbortRequire = 'AbortRequire';
export const RuleResultNotSatisfied = 'RuleResultNotSatisfied';
export const IdmInvalidSession = 'IdmInvalidSession';
export const IdmSessionTimeout = 'IdmSessionTimeout';
export const IdmPermissionDenied = 'IdmPermissionDenied';
export const IsOpenInputRequired = 'ReturnRule_IsOpenInputRequired';
export const ManagerApprovalRequeredOnReturnItem = 'ManagerApprovalRequered';
export const TransactionNotBalanceDue = 'TransactionNotBalanceDue';
export const ItemStatusLockedForSaleException = 'ItemStatusLockedForSaleException';
export const InvalidUnitsInWeighableItem = 'InvalidUnitsInWeighableItem';
export const InhibitQuantityKeyed = 'InhibitQuantityKeyed';
export const ReturnUnitsInCurrentTransactionGreaterThanPurchase =
  'ReturnUnitsInCurrentTransactionGreaterThanPurchase';
export const PaidInProhibhitBeyondBoundryamount = 'PaidInProhibitRestriction995';
export const ProhibitOverTenderRestrictionBehavior = 'ProhibitOverTenderRestrictionBehavior';
export const PaidInManagerApproval = 'PaidInManagerApprovalRestriction995';
export const TenderRequireReferenceNumber = 'TenderRequireReferenceNumber';
export const TenderNotAllowedForChange = 'TenderNotAllowedForChange';
export const EpsAuthorizationCancelled = 'EPSAuthorizationCanceled';
export const InvalidTareValue = 'InvalidTareValue';
export const tillClosingIdmPermissionError = 'IdmPermissionDeniedForLocation';
export const CustomerDetailsForReturnAreInvalid = 'CustomerDetailsForReturnAreInvalid';
export const TransactionNotFound = 'TransactionNotFound';
export const AllMatchingItemsReturnedInPreviousTransactions =
  'AllMatchingItemsReturnedInPreviousTransactions';
export const OriginalBarcodeNotFound = 'OriginalBarcodeNotFound';
export const InvalidValueInWeighableItem = 'InvalidValueInWeighableItem';
export const WeightSmallerThanTare = 'WeightSmallerThanTare';
export const AdditionalTareItemReturnQuantityTooLarge = 'AdditionalTareItemReturnQuantityTooLarge';
export const TareItemReturnQuantityTooLarge = 'TareItemReturnQuantityTooLarge';
export const VoidRxItemInTransactionWithMultipleRxItems =
  'VoidRxItemInTransactionWithMultipleRxItems';
export const EmailAddressRequired = 'EmailAddressRequired';
export const PromotionError = 'PromotionError';
export const PromotionEngineOffline = 'PromotionEngineOffline';
export const FailedMappingRewardResponse = 'FailedMappingRewardResponse';
export const PharmacyServiceError = 'PharmacyServiceError';
export const InvalidBarcode = 'InvalidBarcode';
export const IdmInvalidUserNamePasswordLoginProvided = 'IdmInvalidUserNamePasswordLoginProvided';
export const RefundPaymentRequired = 'RefundPaymentRequired';
export const PaymentRequired = 'PaymentRequired';
export const PrintInfoMissing = 'PrintInfoMissing';
export const NoPrinterConnection = 'NoPrinterConnection';
export const PrintReceiptFailure = 'PrintReceiptFailure';
export const PrintCheckEndorsementFailure = 'PrintCheckEndorsementFailure';
export const PrintCheckEndorsementRemoveTimeOut = 'PrintCheckEndorsementRemoveTimeOut';
export const NotAllLinesReturned = 'NotAllLinesReturned';
export const NoSaleableLinesOnTransaction = 'NoSaleableLinesOnTransaction';
export const ForcedExchangeIsNotCompleted = 'ForcedExchangeIsNotCompleted';
export const RemoveTenderWithInvalidEligibility = 'RemoveTenderWithInvalidEligibility';
export const ReceiptMissingData = 'ReceiptMissingData';
export const TenderMissingRequiredParameters = 'TenderMissingRequiredParameters';
export const VoidAuthorizationCodeRequired = 'VoidAuthorizationCodeRequired';
export const CantVoidTenderThatWasAddedBeforeSuspend = 'CantVoidTenderThatWasAddedBeforeSuspend';
export const CannotVoidTransactionWithTenderLines = 'CannotVoidTransactionWithTenderLines';
export const CartContainItemsThatNotReadyToTender = 'CartContainItemsThatNotReadyToTender';
export const TouchPointNotFound = 'TouchPointNotFound';
export const TenderEndorsementIsRequired = 'TenderEndorsementIsRequired';
export const DataUndefined = 'DataUndefined';
export const InvalidRecallOrderForPickup = 'InvalidRecallOrderForPickup';
export const InterventionsNotFound = 'InterventionsNotFound';
export const InterventionsPending = 'InterventionsPending';
export const R1ClientConfigurationNotFoundException = 'R1ClientConfigurationNotFoundException';
export const R1GeneralOrdersServiceException =
  'R1OrdersServiceException[R1ClientExceptionInternalServerError]';
export const R1OrderNotExist = 'R1OrderNotExist';
export const ItemNotFound = 'ItemNotFound';
export const EmeraldItemNotFound = 'EmeraldItemNotFound';
export const OnlineItemActivationDeclined = 'OnlineItemActivationDeclined';
export const OnlineAuthorizationRequired = 'OnlineAuthorizationRequired';
export const OnlineItemVoidAuthorization = 'OnlineItemVoidAuthorization';
export const OnlineItemExternalIdRequired = 'AuthorizationExternalIdRequired';
export const CartContainOnlineItems = 'CartContainOnlineItems';
export const MissingReasonOnReturnPolicy = 'MissingReasonOnReturnPolicy';
export const PriceRuleByUomNotFound = 'PriceRuleByUOMNotFoundForRequest';
export const PriceEntryRequired = 'PriceEntryRequired';
export const PriceVerifyRequired = 'PriceVerifyRequired';
export const GiftCardMissingActivation = 'GiftCardMissingActivationCode';
export const ElectronicItemExternalIdRequired = 'ElectronicItemExternalIdRequired';
export const ElectronicItemExternalIdMismatch = 'ElectronicItemExternalIdMismatch';
export const QuantityEntryRequired = 'QuantityEntryRequired';
export const QuantityVerificationRequired = 'QuantityVerificationRequired';
export const QuantityWithBarcodeForbbiden = 'QuantityWithBarcodeForbbiden';
export const OnlineItemPriceOverrideForbidden = 'OnlineItemPriceOverrideForbidden';
export const ReturnNonBottleDepositItemNotAllowException =
  'ReturnNonBottleDepositItemNotAllowException';
export const ReturnRuleDenyReturnedItem = 'ReturnRule_DenyReturnedItem';
export const MobilePhoneItemIMEIRequired = 'MobilePhoneItemIMEIRequired';
export const EligibilityAmountExceededWicCvvVouchersOverriden =
  'EligibilityAmountExceededWicCvvVouchersOverriden';
export const InvalidValueInVolumeItem = 'InvalidValueInVolumeItem';
export const NoPriceExistPerUnitOfMeasure = 'NoPriceExistPerUnitOfMeasure';
export const OriginalTransactionLogLineNotFound = 'OriginalTransactionLogLineNotFound';
export const OnlineItemActionNotAllowed = 'OnlineItemActionNotAllowed';
export const MobilePhoneIMEIIsNotValid = 'MobilePhoneIMEIIsNotValid';
export const IdmUserMustChangeBarcode = 'IdmUserMustChangeBarcode';
export const ItemNotFoundInTransaction = 'ItemNotFoundInTransaction';
export const ItemRelatedToCodeNotFound = 'ItemRelatedToCodeNotFound';
export const ItemAlreadyCancelled = 'ItemAlreadyCancelled';
export const ItemRelatedToCodeAlreadyCancelled = 'ItemRelatedToCodeAlreadyCancelled';
export const OnlineItemSwitchRequired = 'OnlineItemSwitchRequired';
export const ReturnQuantityInCurrentTransactionGreaterThanPurchase =
  'ReturnQuantityInCurrentTransactionGreaterThanPurchase';
export const ItemRelatedToCodeAlreadyReturned = 'ItemRelatedToCodeAlreadyReturned';
export const ItemRelatedToCodeLargerQuantityThanPurchased =
  'ItemRelatedToCodeLargerQuantityThanPurchased';
export const RefundRequestRequired = 'RefundRequestRequired';
export const RxItemPriceMisMatch = 'RxItemPriceMisMatch';
export const OfflineRxItemMissingPriceSource = 'OfflineRxItemMissingPriceSource';
export const OfflineRxItemReturnMissingPriceSource = 'OfflineRxItemReturnMissingPriceSource';
export const CannotVoidFueledPrePaidLine = 'CannotVoidFueledPrePaidLine';
export const AlertGroupNotFound = 'AlertGroupNotFound';
export const CannotSuspendTransactionWithPrePaidLines = 'CannotSuspendTransactionWithPrePaidLines';
export const LastColdStartFailedToRun = 'LastColdStartFailedToRun';
export const UserAlreadySignedinInStore = 'UserAlreadySignedinInStore';
export const RestrictionRuleMissingInput = 'RestrictionRuleMissingInput';
export const MaxNumberItemsReached = 'MaxNumberItemsReached';
export const MissingErrorCode = 'MissingErrorCode';
export const CommunicationError = 'CommunicationError';
export const BFFInternalServerError = 'BFFInternalServerError';
export const BRM = 'BRMException';
export const ReturnPolicy = 'ReturnPolicyRequired';
export const AdditionalActionRequest = 'AdditionalActionRequest';
export const LinkedItemHandlingRequired = 'LinkedItemHandlingRequired';
export const DataAddRequired = 'DataAddRequired';
export const Unknown = 'UnknownErrorCode';
export const ModifiedPriceIsHigherThanOriginalPrice = 'ModifiedPriceIsHigherThanOriginalPrice';
export const NewPriceHigherThanOriginal = 'NewPriceHigherThanOriginal';
export const ModifiedPriceIsEqualToOriginalPrice = 'ModifiedPriceIsEqualToOriginalPrice';
export const CouponValueRequired = 'CouponValueRequired';
export const CounterfeitCouponFraud = 'CounterfeitCouponFraud';
export const CustomerNotFound = 'CustomerNotFound';
export const BarcodeNotFoundInTransaction = 'BarcodeNotFoundInTransaction';
export const RedemptionCouponNotIssued = 'RedemptionCouponNotIssued';
export const CouponPromotionExpired = 'CouponPromotionExpired';
export const CouponMemberCardRequired = 'CouponMemberCardRequired';
export const CouponMaxAllowedScans = 'CouponMaxAllowedScans';
export const IdmExitTrainingModeException = 'IdmExitTrainingModeException';

// Client Error Codes
export const SessionExpired = 'SessionExpired';
export const TendersOrderViolation = 'TendersOrderViolation';
export const EwicNoWicAllowedItemInBasketException =
  'EWicBusinessException_EwicNoWicAllowedItemInBasketException';
export const EwicHostOffline = 'EwicHostOffline';
export const EpsRefundFailure = 'EpsRefundFailure';
export const EpsPaymentFailure = 'EpsPaymentFailure';
export const EpsVoidFailure = 'EpsVoidFailure';
export const EpsSignatureCancel = 'EpsSignatureCancel';
export const EpsSignatureFailure = 'EpsSignatureFailure';
export const EpsGetCardDetailsFailure = 'EpsGetCardDetailFailure';
export const TenderAmountExceededEligibilityAmount = 'TenderAmountExceededEligibilityAmount';
export const TenderAmountExceededEligibilityAmountCustomerSearch =
  'TenderAmountExceededEligibilityAmountCustomerSearch';
export const NoEffectiveReturnPolicy = 'NoEffectiveReturnPolicy';
export const TBRTransactionNotFound = 'TBRTransactionNotFound';
export const RetailTransactionLogIsUnreachable = 'RetailTransactionLogIsUnreachable';
export const CartContainCoupons = 'CartContainCoupons';
export const CartContainTendersException = 'CartContainTendersException';
export const Unauthorized = 'Unauthorized';
export const OnlineItemSaleAuthorization = 'OnlineItemSaleAuthorization';
export const ResourceNotFound = 'ResourceNotFound';
export const OnlineItemQuantityForbidden = 'OnlineItemQuantityForbidden';
export const InvalidCoupon = 'InvalidCoupon';
export const TenderChangeAvailability = 'TenderChangeAvailability';
export const WicTenderRestriction = 'WicTenderRestriction';
export const OneGroupItemNotSupported = 'OneGroupItemNotSupported';
export const TooManyUniqueWicItems = 'TooManyUniqueWicItems';
export const WicMixedTransactionRestriction = 'WicMixedTransactionRestriction';
export const TenderExchangeInvalidTender = 'TenderExchangeInvalidTender';
export const PMI_REQUEST_FAILURE = 'PMI_REQUEST_FAILURE';
export const VoidByCodeNotSupportedForWeightItem = 'VoidByCodeNotSupportedForWeightItem';
export const EmbeddedWeightQuantityIsNotAllowed = 'EmbeddedWeightQuantityIsNotAllowed';
export const FailedToPrintReceipt = 'FailedToPrintReceipt';
export const MissingExemptionCustomerIdAndName = 'MissingExemptionCustomerIdAndName';
export const MissingExemptionCustomerId = 'MissingExemptionCustomerId';
export const MissingExemptionCustomerName = 'MissingExemptionCustomerName';
export const TenderExchangeAmountIsOverOrUnderLimitsException =
  'TenderExchangeAmountIsOverOrUnderLimitsException';
export const TenderExchangeAmountNotAccordingMultiplesException =
  'TenderExchangeAmountNotAccordingMultiplesException';
export const SignatureNotVerified = 'SignatureNotVerified';
export const PromotionCanNotBeApplied = 'PromotionCanNotBeApplied';
